export default __webpack_public_path__ + "static/media/teamBonding.fb30b748.png";